<app-dialog-container (onClose)="close()">
    <iframe
        #iframe
        style="min-height: 600px"
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="yes"
        allow="geolocation"
        onload="window.scrollTo(0,0)"
        title="Greenhouse Job Board"
        [src]="iframeSrc"></iframe>
    <div class="text-center prose m-4 lg:m-8" *ngIf="submitted && !finalised">
        <h1 class="text-2xl font-bold text-black space-y-8 sm:space-y-6" i18n>How did we do?</h1>
        <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
            Good luck with your application! How did you find your candidate experience using Voyse today? Please rate
            your experience as a candidate below.
        </p>
        <app-star-rating></app-star-rating>
    </div>

    <div class="text-center prose m-4 lg:m-8" *ngIf="submitted && finalised">
        <h1 class="text-2xl font-bold text-black space-y-8 sm:space-y-6" i18n>Thank you for your application</h1>
        <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
            Thank you for submitting your application and good luck!.
        </p>
    </div>
</app-dialog-container>
